import { LoadingIndicator } from '@trm/ui-kit';
import { useRegistrationFlow } from '~/hooks/useRegistrationFlow';
import AuthWrapperRegisterNew from '~/sections/auth/AuthWrapperRegisterNew';
import AuthRegisterCognitoNew from '~/sections/auth/auth-forms/AuthRegisterCognitoNew';
import AuthRegisterSocialLanding from '~/sections/auth/auth-forms/AuthRegisterSocialLanding';

/**
 * Route component for the social login landing page (/register).
 *
 * Shows social login options + email input when social login is enabled,
 * otherwise shows the new registration form.
 *
 * Behavior:
 * - loading: show spinner
 * - full-featured: render AuthRegisterSocialLanding (with social login options)
 * - new-registration: render AuthRegisterCognitoNew (without social login)
 *
 * Post-registration navigation is determined by AuthRegisterCognitoNew based on
 * the enable-new-trader-onboarding flag.
 *
 * `@example`
 * <SocialLandingRoute />
 *
 * `@see` useRegistrationFlow
 * `@see` EmailRegistrationRoute
 */
const SocialLandingRoute = () => {
  const flow = useRegistrationFlow();

  if (flow.type === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingIndicator size="sm" type="line-spinner" label="Loading registration options" />
      </div>
    );
  }

  // Full-featured: new registration with social login
  if (flow.type === 'full-featured') {
    return (
      <AuthWrapperRegisterNew>
        <AuthRegisterSocialLanding />
      </AuthWrapperRegisterNew>
    );
  }

  // New registration: without social login
  return (
    <AuthWrapperRegisterNew>
      <AuthRegisterCognitoNew />
    </AuthWrapperRegisterNew>
  );
};

export default SocialLandingRoute;
